function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#1B1B1B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.387 38.709c0 8.658-7.019 15.678-15.679 15.678-8.658 0-15.678-7.02-15.678-15.678 0-8.66 7.02-15.68 15.678-15.68 8.66 0 15.68 7.02 15.68 15.68z",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.018 38.709c0 21.157-38.31 61.18-38.31 61.18S.4 59.866.4 38.709C.4 17.55 17.551.399 38.708.399c21.159 0 38.31 17.152 38.31 38.31z",
  transform: "translate(1 1)"
}));

var SvgBluetoothModule02 = function SvgBluetoothModule02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 103,
    viewBox: "0 0 80 103",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBluetoothModule02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bluetooth-module-02.51124418.svg";
export { ForwardRef as ReactComponent };